import { Grid } from '@livecontrol/core-ui';
import type { HTMLAttributes, ReactElement } from 'react';
import Nav from 'react-bootstrap/Nav';
import styled from 'styled-components';

export enum Tab {
  Destinations = 'destinations',
  OperatorNotes = 'operator-notes',
  Performance = 'performance',
  Contacts = 'contacts',
  Routers = 'routers',
  Webplayer = 'webplayer',
  VideographerInfo = 'videographer-info'
}

type Props = HTMLAttributes<HTMLElement> & {
  tab: Tab;
  onSelect: (key?: string | null | undefined) => void;
  eventType?: string;
};

const StyledNav = styled(Nav)`
  padding-bottom: 1px;
  border-bottom: 1px solid var(--white35);
`;

export const Tabber = ({ className, onSelect, tab, eventType }: Props): ReactElement => (
  <StyledNav className={className} variant='tabs' activeKey={tab} onSelect={onSelect}>
    <Grid gridTemplateColumns='1fr min-content' className='w-100'>
      <div className='d-flex flex-wrap row-gap-12px'>
        <Nav.Link key={Tab.OperatorNotes} eventKey={Tab.OperatorNotes}>
          Notes
        </Nav.Link>
        <Nav.Link key={Tab.Destinations} eventKey={Tab.Destinations}>
          Destinations
        </Nav.Link>
        <Nav.Link key={Tab.Performance} eventKey={Tab.Performance}>
          Performance
        </Nav.Link>
        <Nav.Link key={Tab.Contacts} eventKey={Tab.Contacts}>
          Contacts
        </Nav.Link>
        <Nav.Link key={Tab.Routers} eventKey={Tab.Routers}>
          Hardware
        </Nav.Link>
        <Nav.Link key={Tab.Webplayer} eventKey={Tab.Webplayer}>
          Webplayer
        </Nav.Link>
        {eventType === 'Produced' && (<Nav.Link key={Tab.VideographerInfo} eventKey={Tab.VideographerInfo}>
          Videographer Info
        </Nav.Link>)}
      </div>
    </Grid>
  </StyledNav>
);
